import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { operationActions } from "../../util/store/operation/reducer";
import { regionActions } from "../../util/store/region/reducer";
import { siteActions } from "../../util/store/site/reducer";
import Filter from './Filter';
import List from "./List";
import { SiteOverviewProvider } from "./SiteOverviewContext";
import Summary from './Summary';

interface IProps {
}

const SiteOverview: React.FC<IProps> = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(siteActions.getOverview());
        dispatch(siteActions.getFishGroup());
        dispatch(regionActions.getRegions());
        dispatch(operationActions.getStarving());
    }, [dispatch]);

    return <div className='m-header bg-[var(--bgHeader)]'>
        <SiteOverviewProvider>
            <Summary />
            <List />
            <Filter />
        </SiteOverviewProvider>
    </div>;
};

export default SiteOverview;
